import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import { FormattedMessage } from 'react-intl';

// helpers
import { showPaypal } from '../helpers/paypal';
import { showAffirm } from '../helpers/affirm';

import styles from './PdpSharedDetailPayments.scss';

class PdpSharedDetailPaymentsComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {
            cards: {},
        };
    }

    componentDidMount() {
        import(/* webpackChunkName: "PdpSharedPaymentCards" */
        './PdpSharedPaymentCards/PdpSharedPaymentCards').then(cards => {
            if (cards) {
                this.setState({ cards });
            }
        });
    }

    render() {
        const { viewer, item, user, currency } = this.props;
        const { check, paypal, affirm, creditCards, wireTransfer } = this.state.cards;

        return (
            <Fragment>
                <FormattedMessage
                    id="pdpDetails.paymentsPolicy"
                    defaultMessage="1stdibs accepts the following payment methods"
                />
                <div data-tn="pdp-spec-payment-methods" className={styles.container}>
                    {/* Visa / Discover / American Express / Master Card */}
                    {creditCards}
                    {/* Paypal */}
                    {showPaypal({ item, user }) && paypal}
                    {/* Wire Transfer */}
                    {!!(user && (user.isVip || user.isVerifiedTrade)) && wireTransfer}
                    {/* Check */}
                    {!!(user && user.canCheckoutWithCheck) && check}
                    {/* Affirm */}
                    {showAffirm({ viewer, item, user, currency }) && affirm}
                </div>
            </Fragment>
        );
    }
}

PdpSharedDetailPaymentsComponent.propTypes = {
    currency: PropTypes.string,
    viewer: PropTypes.object.isRequired,
    user: PropTypes.object,
    item: PropTypes.object.isRequired,
};

export const PdpSharedDetailPayments = createFragmentContainer(PdpSharedDetailPaymentsComponent, {
    viewer: graphql`
        fragment PdpSharedDetailPayments_viewer on Viewer {
            affirmEnabled: isEnabledByLocale(featureName: "AFFIRM")
            regionalInfo {
                countryCode
            }
        }
    `,
    user: graphql`
        fragment PdpSharedDetailPayments_user on User {
            isVip
            isVerifiedTrade
            canSeeNetPrice: hasPermission(name: "B_NET_PRICE")
            canCheckoutWithCheck: hasPermission(name: "B_CHECKOUT_CHECK")
        }
    `,
    item: graphql`
        fragment PdpSharedDetailPayments_item on Item {
            pdpTypeDisplay
            affirmDisplayInfo: displayInfo {
                showAffirmPromo
            }
            pricing {
                prices {
                    type
                    status
                    amount {
                        convertedAmounts {
                            USD
                        }
                    }
                }
            }
        }
    `,
});
